import script from "./SmallPhaseItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SmallPhaseItem.vue?vue&type=script&setup=true&lang=ts"

import "./SmallPhaseItem.vue?vue&type=style&index=0&id=69d1c5d8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69d1c5d8"]])

export default __exports__